import { AIContextProviderCapabilities, AITextContextChunk, IAIContextProvider } from "../../platform/ai/common/ai.js";

/**
 * Tells the model that the headless agent is a PREVIEW surface.
 *
 * Registered ONLY by the agent entry point — the browser editor is the full
 * product and says nothing of the sort. Headless, the model is the only thing in
 * the room: a limit it does not know about reads to the user as a broken tool,
 * and there is no UI to point them anywhere.
 *
 * Deliberately short — this rides along with every message.
 */
export class AIAgentPreviewContext implements IAIContextProvider {
    readonly name = "agent-preview";
    readonly capabilities: AIContextProviderCapabilities = AIContextProviderCapabilities.Text;

    async getContext(): Promise<AITextContextChunk[] | null> {
        return [{
            type: "text",
            text: "This is the Needle Inspector HEADLESS AGENT — a preview. It carries a subset of "
                + "what the Needle Inspector offers in the browser, so some capabilities are absent "
                + "or reduced here. When something is unavailable, say so plainly and tell the user "
                + "to contact hi@needle.tools about the full version.",
        }];
    }
}
